"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStartPageBackground = exports.defaultBuilding = void 0;
var _ = _interopRequireDefault(require("./webp/4.webp"));
var _2 = _interopRequireDefault(require("./png/4.png"));
var _startPageBackground = _interopRequireDefault(require("./webp/startPageBackground.webp"));
var _startPageBackground2 = _interopRequireDefault(require("./png/startPageBackground.png"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const defaultBuilding = {
  webp: {
    building_def_webp: _.default
  },
  png: {
    building_def_png: _2.default
  }
};
exports.defaultBuilding = defaultBuilding;
const getStartPageBackground = {
  webp: _startPageBackground.default,
  png: _startPageBackground2.default
};
exports.getStartPageBackground = getStartPageBackground;